import React, { HTMLAttributes } from "react";

interface IContainerProps extends HTMLAttributes<HTMLElement> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isSection?: boolean;
}


const ContainerComponent: React.FC<IContainerProps> = ({ className, isSection, ...props }: IContainerProps): JSX.Element => {

    const containerProps = {
        className: `container${className ? ` ${className}` : ''}`,
        ...props
    };

    return isSection
        ? <section {...containerProps} />
        : <div {...containerProps} />;

};

export const Container = React.memo(ContainerComponent);

